import { Badge } from "@nexus/ui";
import { useTranslation } from "react-i18next";

import {
  SCRIPT_PLATFORM_LABELS,
  scriptPlatformFromFormat,
} from "../../lib/script-platform.js";

export function ScriptPlatformBadge({
  format,
}: {
  format: string | null | undefined;
}) {
  const { t } = useTranslation();
  const platform = scriptPlatformFromFormat(format);
  const label = t(`personaOpportunities.scripts.platform.${platform}`, SCRIPT_PLATFORM_LABELS[platform]);

  return (
    <Badge variant="slate" data-testid="script-platform-badge">
      {label}
    </Badge>
  );
}
